import { type RcFile } from 'antd/es/upload';
import { useMemo } from 'react';
import { useController } from '../../hooks/useController.ts';
import { useFormItemAccessibility } from '../../item/useFormItemAccessibility.tsx';
import { UploadInput, type UploadInputProps } from './UploadInput.tsx';

export interface FileUploadInputProps extends UploadInputProps {
  name: string;
}

export function FileUploadInput({
  name,
  ...uploadProps
}: Readonly<FileUploadInputProps>) {
  const { field } = useController(name);
  const accessibility = useFormItemAccessibility();

  const file = field.value as RcFile | null;
  const fileList = useMemo(() => (file ? [file] : []), [file]);
  const buttonProps = useMemo(
    () => ({
      ...uploadProps.buttonProps,
      disabled: uploadProps.disabled,
    }),
    [uploadProps.disabled, uploadProps.buttonProps],
  );

  return (
    <UploadInput
      {...accessibility.attributes}
      name={name}
      fileList={fileList}
      beforeUpload={file => {
        field.onChange(file);
        return false;
      }}
      onRemove={() => field.onChange(null)}
      {...uploadProps}
      buttonProps={buttonProps}
    />
  );
}
